import React from 'react';
import Link from 'gatsby-link';
import { H1, H3 } from '../components/Headers';
import TagsPage from "../pages/tags/tags-list";
import { Container } from "../components/Skeleton";
require("prismjs/themes/prism-solarizedlight.css");

class Template extends React.Component {
  render() {
    const { location, children } = this.props;
    let header;
    if (location.pathname === '/tags') {
      return (
        <Container>
          <TagsPage/>
        </Container>
      )
    }
    if (location.pathname === '/') {
      header = (
        <div style={{ textAlign: 'center' }}>
          <H1 style={{ borderBottom: 'none' }}>
            <Link to={'/'}>
              Henry Moulton
            </Link>
          </H1>
          <div style={{ margin: '10px' }}>
            <H3>
              Technology, React Native and The Future<br />
              :)
            </H3>
          </div>

        </div>
      );
    } else {
      header = (
        <div style={{ textAlign: 'center' }}>
          <H3>
            <Link to={'/'}>
              Henry Moulton
            </Link>
          </H3>
        </div>
      );
    }
    return (
      <div>
        {header}
        {children()}
      </div>
    );
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object
};

export default Template;



// WEBPACK FOOTER //
// ./src/layouts/index.js